module.exports = __webpack_public_path__ + "static/media/btn_kakao.6c12c484.png";